var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":"","align":"center"}},[_c('v-col',{staticClass:"text-right",attrs:{"md":"10","sm":"9","cols":"9"}},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('v-col',{attrs:{"md":"2","sm":"3","cols":"3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }